
<ion-modal #modalEmergency>
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-label *ngIf="clinicContacts && clinicContacts.length > 0" class="ion-text-wrap" slot="start"><span *ngFor="let clinicContact of clinicContacts"><strong>{{ clinicContact.name }}</strong>&nbsp;<a href="tel:{{ clinicContact.phone }}">{{ clinicContact.phone }}</a>&nbsp;</span></ion-label>
        <ion-buttons slot="end">
          <ion-button (click)="closeModal($event)" [strong]="true">{{ 'Close' | translate }}</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding #content>

      <div class="frames">

        <ng-container *ngIf="clinicContacts && clinicContacts.length == 0">
          <ion-item class="frame" lines="none">
            <div class="content verticalCenter">
              <div class="line">
                <p>{{ 'Add your veterinarian\'s information so you can contact them quickly.' | translate }}</p>
              </div>
              <div class="line">
                <div class="description w100 right moreInformation">
                  <a href="#" (click)="closeModalAndAddVet($event)"><ion-icon name="caret-forward-outline"></ion-icon>{{ 'add my vet' | translate }}</a>
                </div>
              </div>
            </div>
          </ion-item>
        </ng-container>

        <ng-container *ngIf="clinicContacts && clinicContacts.length > 0">
          <ion-item class="frame" lines="none">
            <div class="content verticalCenter">
              <div class="line">
                <div class="description w100 center">
                  <ion-icon slot="start" name="storefront-outline" style="font-size: 6em;"></ion-icon>
                </div>
              </div>
              <div class="line">
                <div class="description w100 center">
                  {{ 'In case of emergency, contact your veterinarian immediately.' | translate }}
                </div>
              </div>
              <div class="line">
                <div class="description w100 center">
                  &nbsp;
                </div>
              </div>
              <ng-container *ngFor="let clinicContact of clinicContacts">
                <div class="line">
                  <div class="description w100 center">
                    <p class="title">{{ clinicContact.name }}</p>
                  </div>
                </div>
                <div class="line">
                  <div class="description w100 center">
                    <p class="subtitle"><ion-icon name="call" class="iconClinicContact"></ion-icon> <a href="tel:{{ clinicContact.phone }}">{{ clinicContact.phone }}</a></p>
                  </div>
                </div>
                <div class="line" *ngIf="clinicContact.email">
                  <div class="description w100 center">
                    <p class="subtitle"><ion-icon name="mail" class="iconClinicContact"></ion-icon> <a href="mailto:{{ clinicContact.email }}">{{ clinicContact.email }}</a></p>
                  </div>
                </div>
              </ng-container>
            </div>
          </ion-item>
        </ng-container>
      </div>

      <div class="chatIA" *ngIf="chatMessages">
        <div class="bubble left">
          <p>{{ 'Hello! I\'m an AI and can provide you with quick clarifications. For any health questions, a veterinarian is essential.' | translate }}</p>
        </div>
        <div *ngFor="let chatMessage of chatMessages">
          <div class="bubble right" id="iachat__message__{{ chatMessage.id }}"><p [innerHTML]="chatMessage.message"></p></div>
          <div [innerHTML]="chatMessage.response" class="bubble left" id="iachat__response__{{ chatMessage.id }}">
          </div>
          <ion-icon class="iconReportAbuse" name="alert-circle-outline" color="danger" (click)="reportAbuse.msg = chatMessage.response;reportAbuse.present()"></ion-icon>
        </div>
      </div>

    </ion-content>
    <ion-footer>
      <ion-toolbar style="padding-top: 0; padding-left: 0; padding-right: 0;">
        <ion-button (click)="voiceReverseCB()" slot="start" size="small" fill="clear" style="--padding-start: 0em; --padding-end: 0em; padding-bottom: 0.4em; margin-right: 0.5em;" *ngIf="!isVoiceRunning">
          <ion-icon slot="icon-only" name="volume-mute" style="font-size: 2em;" *ngIf="!isVoiceActivated" color="danger"></ion-icon>
          <ion-icon slot="icon-only" name="volume-high" style="font-size: 2em;" *ngIf="isVoiceActivated" color="success"></ion-icon>
        </ion-button>
        <ion-button (click)="voiceStop()" slot="start" size="small" fill="clear" style="--padding-start: 0em; --padding-end: 0em; padding-bottom: 0.4em; margin-right: 0.5em;" *ngIf="isVoiceRunning">
          <ion-icon slot="icon-only" name="close-circle" style="font-size: 2em;" color="danger"></ion-icon>
        </ion-button>
        <ion-button (click)="speechRecognitionStartCB()" slot="start" size="small" fill="clear" style="--padding-start: 0em; --padding-end: 0em; padding-bottom: 0.4em; margin-right: 0.5em;" *ngIf="isSpeechRecognitionAvailable">
          <ion-icon slot="icon-only" name="mic" style="font-size: 2em;"></ion-icon>
        </ion-button>
        <form [formGroup]="formChat">
          <ion-textarea formControlName="msg" placeholder="{{ 'Message ...' | translate }}" class="chat" rows="1"></ion-textarea>
        </form>
        <ion-button (click)="msgAddCB()" slot="end" size="small" fill="clear" style="--padding-start: 0em; --padding-end: 0em; padding-bottom: 0.4em;margin-left: 0.5em;">
          <ion-icon slot="icon-only" name="rocket" style="font-size: 2em;"></ion-icon>
        </ion-button>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>

<report-abuse source="ChatIA" #reportAbuse></report-abuse>